/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    ACTIVE: 'active',
    ARCHIVED: 'archived',
    BLOCKED: 'blocked',
};
